import { Component, OnInit, ViewChild } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { ChannelReviewSearchParams, ChannelReviewsResponse, ReviewService } from '@tokeet-frontend/reviews'
import {
  ChannelNameTokens,
  Destroyable,
  DialogService,
  selectIsChannelConnected,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { ChannelHelperService } from '@tv3/containers/channels/channel-connect/channel-helper.service'
import * as lodash from 'lodash'
import { combineLatest, Subject } from 'rxjs'
import { debounceTime, map, switchMap, tap } from 'rxjs/operators'
import { ReviewAutomationsOverlayComponent } from '../../automations/review/automations-overlay/review-automations-overlay.component'
import { RecentReviewsComponent } from './recent-reviews/recent-reviews.component'
import { selectActiveProductPlanView } from '@tv3/store/plan/plan.selectors'
import { ProductsForPlan } from '@tv3/store/plan/plan.model'

@Component({
  selector: 'app-reviews-dashboard',
  templateUrl: './reviews-dashboard.component.html',
  styleUrls: ['./reviews-dashboard.component.scss'],
})
export class ReviewsDashboardComponent extends Destroyable implements OnInit {
  @ViewChild('reviews') reviews: RecentReviewsComponent

  reviewTab: 'recent' | 'insights' = 'recent'

  source: string
  filters: ChannelReviewSearchParams
  data: ChannelReviewsResponse
  isLoading = false

  refresh$ = new Subject<ChannelReviewSearchParams>()

  isAnyChannelConnected$ = combineLatest([
    this.store.pipe(select(selectIsChannelConnected(ChannelNameTokens.AirBnBV2API))),
    this.store.pipe(select(selectIsChannelConnected(ChannelNameTokens.BookingAPI))),
    this.store.pipe(select(selectIsChannelConnected(ChannelNameTokens.ExpediaAPI))),
    this.store.pipe(select(selectIsChannelConnected(ChannelNameTokens.Homeaway))),
  ]).pipe(map((items) => lodash.some(items)))

  isAISubscribed$ = this.store.pipe(
    select(selectActiveProductPlanView(ProductsForPlan.TokeetAI)),
    map((res) => res || {})
  )

  constructor(
    private store: Store<any>,
    private dialog: DialogService,
    private channelHelperService: ChannelHelperService,
    private reviewService: ReviewService
  ) {
    super()
  }

  ngOnInit(): void {
    this.refresh$
      .pipe(
        debounceTime(250),
        untilDestroy(this),
        tap(() => (this.isLoading = true)),
        switchMap((filters) => this.reviewService.getReviewStats(filters))
      )
      .subscribe((res) => {
        this.isLoading = false
        this.data = res
      })
  }

  onAddChannel() {
    this.channelHelperService.connectChannel()
  }

  onAddAutomation() {
    this.dialog.openDrawer(ReviewAutomationsOverlayComponent, { panelClass: 'drawer-full-70' })
  }

  onFiltersChange(filters: ChannelReviewSearchParams) {
    if (!lodash.isEqual(filters, this.filters)) {
      this.filters = filters
      this.refresh$.next(filters)
    }
  }

  onRefresh() {
    this.refresh$.next(this.filters)
    this.reviews?.refresh()
  }
}
